tinymce.PluginManager.add('mark', function(editor) {
    editor.addButton('mark', {
        text: false,
        icon: 'backcolor',
        tooltip: 'Mark as "Hulpmiddel"',
        onpostrender: monitorNodeChange,
        onclick: function() {
            const selectedContent = editor.selection.getContent();

            var targetNodeStart = '<mark href="#" data-toggle="modal" data-target="#solving-strategy-modal-concept-list">';
            var targetNodeEnd = '</mark>';
            var newContent = '';
            if (editor.selection.getNode().nodeName.toLowerCase() === 'mark' && $(editor.selection.getNode()).attr('data-target') === '#solving-strategy-modal-concept-list') {
                newContent = selectedContent.replace(targetNodeStart, '').replace(targetNodeEnd, '');
            } else {
                newContent = targetNodeStart + selectedContent + targetNodeEnd;
            }

            editor.insertContent(newContent);
        }
    });

    function monitorNodeChange() {
        var btn = this;
        editor.on('NodeChange', function(e) {
            btn.active(e.element.nodeName.toLowerCase() === 'mark');
        });
    }
});